import React, { useState } from 'react';

/**
 * Password field with show/hide toggle.
 * @param {object} props
 * @param {string} props.value
 * @param {(e: React.ChangeEvent<HTMLInputElement>) => void} props.onChange
 * @param {string} [props.id]
 * @param {string} [props.placeholder]
 * @param {string} [props.autoComplete]
 * @param {number} [props.minLength]
 * @param {boolean} [props.required]
 * @param {boolean} [props.disabled]
 * @param {React.CSSProperties} [props.style] - wrapper
 * @param {React.CSSProperties} [props.inputStyle] - input overrides
 * @param {string} [props.toggleColor]
 */
export default function PasswordInput({
  value,
  onChange,
  id,
  placeholder,
  autoComplete = 'current-password',
  minLength,
  required,
  disabled,
  style,
  inputStyle = {},
  toggleColor = '#9aa0a6',
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div style={{ position: 'relative', width: '100%', ...style }}>
      <input
        id={id}
        type={visible ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        autoComplete={autoComplete}
        minLength={minLength}
        required={required}
        disabled={disabled}
        style={{
          width: '100%',
          boxSizing: 'border-box',
          padding: '12px 52px 12px 14px',
          borderRadius: 10,
          border: '1px solid rgba(255,255,255,0.12)',
          background: '#0f1419',
          color: '#e8eaed',
          fontSize: '1rem',
          outline: 'none',
          ...inputStyle,
        }}
      />
      <button
        type="button"
        aria-label={visible ? 'Hide password' : 'Show password'}
        aria-pressed={visible}
        disabled={disabled}
        onClick={() => setVisible((v) => !v)}
        style={{
          position: 'absolute',
          right: 10,
          top: '50%',
          transform: 'translateY(-50%)',
          border: 'none',
          background: 'transparent',
          color: toggleColor,
          cursor: disabled ? 'not-allowed' : 'pointer',
          fontSize: '0.8rem',
          fontWeight: 600,
          padding: '4px 2px',
          lineHeight: 1,
        }}
      >
        {visible ? 'Hide' : 'Show'}
      </button>
    </div>
  );
}
